import { useCallback, useEffect, useState, useContext } from "react"

import server from "server/serverController2"
import { AnimatedWindowCallbackContext } from "context/window/AnimatedWindowProvider"

import ShippingAddressForm from "components/containers/commerce/order/ShippingAddressForm"

const useShippingList = ({ onComplete }) => {
  const { openWindow, closeWindow, id } = useContext(AnimatedWindowCallbackContext)

  const [shippingList, setShippingList] = useState([])
  const [currShipping, setCurrShipping] = useState(null)
  const [isChangeDefault, setIsChangeDefault] = useState(false)

  const loadShippingData = useCallback(async () => {
    try {
      const response = await server.getRequestData(`users/shippings`)
      if (response.success !== 1) {
        const errData = response.error.res_data
        throw errData.detail_code
      }
      const { shippings } = response.data

      return shippings
    } catch (error) {
      alert("주문 정보 조회를 실패했어요. 관리자에게 문의해주세요.")
    }
  }, [])

  const handleSetShippingList = useCallback(async () => {
    const shippings = await loadShippingData()

    setShippingList(shippings)

    for (const shipping of shippings) {
      if (shipping.is_default) {
        setCurrShipping(shipping)
        return
      }
    }
    setCurrShipping(null)
  }, [loadShippingData])

  const handleChangeCurrShipping = (shipping) => {
    setCurrShipping(shipping)
  }

  const handleToggleDefault = () => {
    setIsChangeDefault((isDefault) => !isDefault)
  }

  const handleDeleteShipping = useCallback(
    async (shippingNo) => {
      try {
        const response = await server.deleteRequestData(`users/shippings/${shippingNo}`)
        if (response.success !== 1) {
          const errData = response.error.res_data
          throw errData.detail_code
        }

        handleSetShippingList()
      } catch (error) {
        console.log(error)
      }
    },
    [handleSetShippingList]
  )

  const handleSave = useCallback(async () => {
    try {
      if (isChangeDefault) {
        const response = await server.putRequestData(`users/shippings/${currShipping.no}/default`)

        if (response.success !== 1) {
          const errData = response.error.res_data
          throw errData.detail_code
        }

        if (onComplete) onComplete(currShipping)
      } else {
        if (onComplete) onComplete(currShipping)
      }
    } catch (error) {
      alert("기본 주소지 수정을 실패했어요. 나중에 다시 시도해주세요.")
    }
  }, [currShipping, isChangeDefault, onComplete])

  const handleCompleteAddAddress = useCallback(() => {
    closeWindow(id)
    handleSetShippingList()
  }, [closeWindow, handleSetShippingList, id])

  const openShippingAddressForm = () => {
    openWindow({
      id,
      Component: <ShippingAddressForm onComplete={handleCompleteAddAddress} />,
      headerProps: {
        title: "배송지 추가",
      },
    })
  }

  useEffect(() => {
    handleSetShippingList()
  }, [handleSetShippingList])

  return {
    shippingList,
    currShipping,
    isChangeDefault,
    handleDeleteShipping,
    handleChangeCurrShipping,
    handleToggleDefault,
    openShippingAddressForm,
    handleSave,
  }
}

export default useShippingList
